

<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="GenealogyTable" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import { GenealogyTableProps } from './GenealogyTable.ts';
import GenealogyTable from './GenealogyTable.vue';
import GravManagerWrapper from './GravManagerWrapper.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-genealogy-table';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<GenealogyTableProps>();
const changableProps = useChangableProps(componentName, props);

</script>
